<template>
  <div class="apprentice">
    <NavBtn
      :on-click="back"
    />

    <div class="nav">
      <div class="title">我的奖励</div>
      <div class="tab">
        <div class="tab-btn" @click="tabClick(1)">未领奖励<div class="bottom" v-if="pageIndex == 1"></div></div>
        <div class="tab-btn" @click="tabClick(2)">已领奖励<div class="bottom" v-if="pageIndex == 2"></div></div>
        <div class="tab-btn" @click="tabClick(3)">过期奖励<div class="bottom" v-if="pageIndex == 3"></div></div>
      </div>
    </div>

    <scroller class="scroll" ref='scrollers' :on-infinite="infinite" noDataText="" v-if="pageIndex == 1">
      <div class="member" v-for="(apprentice, index) in unreceived_rewards" :key="index">
        <img :src="apprentice.portrait" alt="">
        <div class="info">
          <div class="name">{{apprentice.nickname}}</div>
          <div class="desc">{{apprentice.message}}</div>
          <div class="date">{{apprentice.created_day}}</div>
        </div>
        <span class="reward">
          <span>奖励</span>
          <span>{{apprentice.reward}}</span>
          <span>元</span>
        </span>
      </div>
      <div style="height: 50px;"></div>
    </scroller>

    <scroller class="scroll" ref='scrollers' :on-infinite="infinite" noDataText="" v-if="pageIndex == 2">
      <div class="member" v-for="(apprentice, index) in received_rewards" :key="index">
        <img :src="apprentice.portrait" alt="">
        <div class="info">
          <div class="name">{{apprentice.nickname}}</div>
          <div class="desc">{{apprentice.message}}</div>
          <div class="date">{{apprentice.created_day}}</div>
        </div>
        <span class="reward">
          <span>奖励</span>
          <span>{{apprentice.reward}}</span>
          <span>元</span>
        </span>
      </div>
      <div style="height: 50px;"></div>
    </scroller>

    <scroller class="scroll" ref='scrollers' :on-infinite="infinite" noDataText="" v-if="pageIndex == 3">
      <div class="member" v-for="(apprentice, index) in invalid_rewards" :key="index">
        <img :src="apprentice.portrait" alt="">
        <div class="info">
          <div class="name">{{apprentice.nickname}}</div>
          <div class="desc">{{apprentice.message}}</div>
          <div class="date">{{apprentice.created_day}}</div>
        </div>
        <span class="reward">
          <span>奖励</span>
          <span>{{apprentice.reward}}</span>
          <span>元</span>
        </span>
      </div>
      <div style="height: 50px;"></div>
    </scroller>
  </div>
</template>
<style lang='scss' scoped>
  @media only screen and (device-height: 812px) {
    .nav {
      padding-top: 64px !important;
    }
  }
  .nav {
    position: fixed;
    padding-top: 54px;
    width: 100%;
    background-color: #3A4E92;
    z-index: 10;
    top: -10px;
  }
  .scroll {
    padding-top: 155px;
  }
  .apprentice {
    background-color: #3A4E92;
    padding-top: 24px;

    .back {
      position: absolute;
      top: 16px;
      left: 20px;
      width: 40px;
      height: 40px;
      background: #342F74;
      box-shadow: 0 3px 5px 0 #36308E;
      border-radius: 50%;
    }

    .title {
      text-align: center;
      font-size: 18px;
      color: #FFFFFF;
      margin-bottom: 30px;

      @include regular();
    }

    .tab {
      height: 24px;
      margin-bottom: 20px;
      text-align: center;

      .tab-btn {
        display: inline-block;
        font-size: 16px;
        color: #FFFFFF;

        @include semibold();

        .bottom {
          width: 62px;
          height: 2px;
          background: #FFFFFF;
          border-radius: 1px;
          margin: 0 auto;
        }
      }

      div:first-child, div:nth-child(2) {
        margin-right: 30px;
      }
    }

    .member {
      font-size: 0;
      margin: 0 auto 10px;
      background: #FFFFFF;
      box-shadow: 0 3px 5px 0 #2C2683;
      border-radius: 8px;
      width: 335px;
      height: 90px;
      padding: 16px 15px;
      display: flex;
      align-items: center;

      img {
        border-radius: 8px;
        width: 36px;
        height: 36px;
        margin-right: 10px;
      }

      .info {
        display: inline-block;
        max-width: 180px;

        div {
          font-size: 13px;
          color: #3A3A3A;
          margin-bottom: 2px;

          @include regular();
        }

        div:nth-child(2){
          width: 170px;
          height: 38px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;

        }

        div:last-child {
          margin-bottom: 0px;
          color: #B5B5B5;
        }
      }

      .reward {
        flex: 1;
        text-align: right;

        span:first-child {
          font-size: 13px;
          color: #B5B5B5;
          margin-right: 5px;

          @include regular();
        }

        span:nth-child(2) {
          font-size: 18px;
          color: #3A3A3A;
          margin-right: 1px;
          position: relative;
          top: 1px;

          @include roboto();
        }

        span:nth-child(3) {
          font-size: 13px;
          color: #3A3A3A;

          @include semibold();
        }
      }
    }
  }
</style>
<script>
  import { mapState, mapActions } from 'vuex'
  import { URI_MY_COMMISION, URI_MORE_COMMISSION } from '@/store/modules/account/type'
  export default {
    data () {
      return {
        pageIndex: 1,
        limit: 12,
        noMoreReceived: false,
        noMoreUnreceived: false,
        noMoreInvalid: false,
        receivedOffset: undefined,
        unreceiveOffset: undefined,
        invalidOffset: undefined
      }
    },
    computed: {
      ...mapState({
        unreceived_rewards: state => state.account.unreceived_rewards,
        received_rewards: state => state.account.received_rewards,
        invalid_rewards: state => state.account.invalid_rewards
      })
    },
    async mounted () {
      await this.getCommission()
      this.receivedOffset = this.received_rewards[this.received_rewards.length - 1].apprentice_uid
      this.unreceiveOffset = this.unreceived_rewards[this.unreceived_rewards.length - 1].apprentice_uid
      this.invalidOffset = this.invalid_rewards[this.invalid_rewards.length - 1].apprentice_uid
    },
    methods: {
      ...mapActions({
        getCommission: URI_MY_COMMISION,
        getMore: URI_MORE_COMMISSION
      }),
      back () {
        this.$router.push('/dashboard')
      },
      tabClick (index) {
        this.pageIndex = index
      },
      async infinite (done) {
        let last_id
        if (this.pageIndex === 1) {
          if (this.noMoreUnreceived || this.unreceiveOffset === undefined) {
            done(true)
            return
          }
          last_id = this.unreceiveOffset
        } else if (this.pageIndex === 2 || this.receivedOffset === undefined) {
          if (this.noMoreReceived) {
            done(true)
            return
          }
          last_id = this.receivedOffset
        } else {
          if (this.noMoreInvalid || this.invalidOffset === undefined) {
            done(true)
            return
          }
          last_id = this.invalidOffset
        }
        let params = {
          tab: this.pageIndex,
          limit: this.limit,
          last_id: last_id
        }
        const res = await this.getMore(params)
        if (res && res.status === 200) {
          const data = res.data.paylaod.rewards
          if (this.pageIndex === 1) {
            this.noMoreUnreceived = data.length < this.limit
            this.unreceiveOffset = this.unreceived_rewards[this.unreceived_rewards.length - 1].apprentice_uid
            done(this.noMoreUnreceived)
          } else if (this.pageIndex === 2) {
            this.noMoreReceived = data.length < this.limit
            this.receivedOffset = this.received_rewards[this.received_rewards.length - 1].apprentice_uid
            done(this.noMoreReceived)
          } else {
            this.noMoreInvalid = data.length < this.limit
            this.invalidOffset = this.invalid_rewards[this.invalid_rewards.length - 1].apprentice_uid
            done(this.noMoreInvalid)
          }
        }
      }
    }
  }
</script>
